import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReactNode, useId } from 'react';
import colorConfigs from '../../configs/colorConfigs';

interface RecordDetailDialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  wide?: boolean;
  compactHeader?: boolean;
}

/** The same centered, scrollable detail surface used by Customer Accounts. */
export default function RecordDetailDialog({ open, title, onClose, children, wide = false, compactHeader = false }: RecordDetailDialogProps) {
  const titleId = useId();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={titleId}
      fullWidth
      maxWidth={wide ? 'xl' : 'sm'}
      scroll="paper"
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: 'calc(100dvh - 32px)',
          width: 'calc(100% - 24px)',
          ...(compactHeader ? { borderRadius: '10px' } : {}),
        },
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <DialogTitle id={titleId} sx={{
          color: colorConfigs.tables.headBg,
          fontWeight: 700,
          overflowWrap: 'anywhere',
          ...(compactHeader ? {
            minHeight: 52, boxSizing: 'border-box', px: 6, py: 1,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            textAlign: 'center', fontSize: '1.125rem', lineHeight: 1.3,
          } : { pr: 7 }),
        }}>
          {title}
        </DialogTitle>
        <IconButton
          aria-label="Close details"
          onClick={onClose}
          size={compactHeader ? 'small' : 'medium'}
          sx={{ position: 'absolute', top: compactHeader ? '50%' : 8, right: 8, ...(compactHeader ? { transform: 'translateY(-50%)' } : {}) }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ px: { xs: 1, sm: 2 }, py: 1, overflowX: 'auto' }}>
        <Box sx={{ minWidth: 0 }}>{children}</Box>
      </DialogContent>
    </Dialog>
  );
}
